// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"267":"Setting","268":"Home","330":"Transaction","393":"Card","651":"Errors","726":"Index"}[chunkId] + "." + {"267":"f83b9a2c","268":"f83b9a2c","330":"f83b9a2c","393":"f83b9a2c","651":"2514bb1e","726":"f83b9a2c"}[chunkId] + ".css";
};